module.exports = __webpack_public_path__ + "fb253ac6058651ed64066386d285b384.jpg";